import React from 'react';
import classNames from 'classnames';

import './ActionsContainer.scss';

export const ActionsContainer = ({ children, desktopLayout = 'column' }) => {
  return (
    <div styleName={classNames('actions-container', {'actions-container--row': desktopLayout === 'row'})}>{children}</div>
  );
};
